import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=537be346&scoped=true&"
import script from "./ServerError.vue?vue&type=script&lang=js&"
export * from "./ServerError.vue?vue&type=script&lang=js&"
import style0 from "./ServerError.vue?vue&type=style&index=0&id=537be346&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537be346",
  null
  
)

export default component.exports